import { DateTime } from 'luxon'
import { PrivateUserInfoType, QuotaType, Vehicle } from '@otw/models'

export function getQuotaProgressLabel(type: QuotaType): string {
  return type === 'inventory_trucks' ? 'Trucks purchased for inventory' : 'Vehicles sold'
}

export function getInventoryTrucksForQuota(
  user: PrivateUserInfoType,
  vehicles: Vehicle[],
  startOfMonth: DateTime,
  endOfMonth: DateTime,
): Vehicle[] {
  return vehicles.filter((vehicle) => {
    if (vehicle.purchased_for_inventory !== true || vehicle.entered_by !== user.email) {
      return false
    }
    const purchasedDate = vehicle.purchased_for_inventory_date
    if (!purchasedDate) return false
    const date = DateTime.fromISO(purchasedDate)
    return date.isValid && date >= startOfMonth && date <= endOfMonth
  })
}

export function getSoldVehiclesForQuota(
  user: PrivateUserInfoType,
  vehicles: Vehicle[],
  startOfMonth: DateTime,
  endOfMonth: DateTime,
): Vehicle[] {
  return vehicles.filter((vehicle) => {
    if (vehicle.status !== 'Sold' || vehicle.sold_date == null || vehicle.sold_by_user?.id !== user.id) {
      return false
    }
    const soldDate = DateTime.fromISO(vehicle.sold_date)
    return soldDate.isValid && soldDate >= startOfMonth && soldDate <= endOfMonth
  })
}

export function getVehiclesForQuota(
  type: QuotaType,
  user: PrivateUserInfoType,
  vehicles: Vehicle[],
  startOfMonth: DateTime,
  endOfMonth: DateTime,
): Vehicle[] {
  return type === 'inventory_trucks'
    ? getInventoryTrucksForQuota(user, vehicles, startOfMonth, endOfMonth)
    : getSoldVehiclesForQuota(user, vehicles, startOfMonth, endOfMonth)
}

export function sortQuotaVehicles(type: QuotaType, vehicles: Vehicle[]): Vehicle[] {
  return [...vehicles].sort((a, b) => {
    const dateA =
      type === 'inventory_trucks' ? a.purchased_for_inventory_date ?? '' : a.sold_date ?? ''
    const dateB =
      type === 'inventory_trucks' ? b.purchased_for_inventory_date ?? '' : b.sold_date ?? ''
    return dateB.localeCompare(dateA)
  })
}

export function countQuotaProgressForUser(
  type: QuotaType,
  user: PrivateUserInfoType,
  vehicles: Vehicle[],
  startOfMonth: DateTime,
  endOfMonth: DateTime,
): number {
  return getVehiclesForQuota(type, user, vehicles, startOfMonth, endOfMonth).length
}
